/* Generated by restful-react */

import React from 'react'
import { Mutate, MutateProps, useMutate, UseMutateProps } from 'restful-react'

export const SPEC_VERSION = 'v9'
export interface SpotBiddingRulesErrorResponse {
  errors?: string[]
}

export interface CreateSpotBiddingRuleRequest {
  spotBiddingRule: {
    spotBiddingConfigId?: number
    shipperApplicationId?: number
    ruleAction: 'APPLY_PREMIUM' | 'DONT_BID'
    isSameDay?: boolean
    isWeekend?: boolean
    deletedAt?: string
    spotPremium?: {
      premiumType: 'PERCENTAGE'
      amount: number
    }
    geographicCriteriaAttributes?: {
      criteriaType: 'REGION' | 'STATE' | 'CITY, STATE' | 'DAT MARKET'
      value: string
      isInbound: boolean
    }
    proximalHourCriteria?: {
      rangeStart?: number
      rangeEnd?: number
    }
    ruleStartTimeCriteria?: {
      rangeStart?: string
    }
    parentEquipmentKey?: string | null
    dateCriteria?: {
      rangeStart?: string
      rangeEnd?: string
    }
    mileageCriteria?: {
      rangeStart: number
      rangeEnd?: number
    }
    reason?: string
    namespace: 'spot_control_panel' | 'strike_price_panel'
  }
}

export interface UpdateSpotBiddingRuleRequest {
  spotBiddingRule: {
    spotBiddingConfigId?: number
    shipperApplicationId?: number
    ruleAction?: 'APPLY_PREMIUM' | 'DONT_BID'
    isSameDay?: boolean
    isWeekend?: boolean
    deletedAt?: string
    spotPremium?: {
      premiumType: 'PERCENTAGE'
      amount: number
    }
    geographicCriteriaAttributes?: {
      criteriaType: 'REGION' | 'STATE' | 'CITY, STATE' | 'DAT MARKET'
      value: string
      isInbound: boolean
    }
    proximalHourCriteria?: {
      rangeStart?: number
      rangeEnd?: number
    }
    ruleStartTimeCriteria?: {
      rangeStart?: string
    }
    dateCriteria?: {
      rangeStart?: string
      rangeEnd?: string
    }
    mileageCriteria?: {
      rangeStart: number
      rangeEnd?: number
    }
    reason?: string
    namespace?: 'spot_control_panel' | 'strike_price_panel'
  }
}

export type CreateSpotBiddingRuleProps = Omit<
  MutateProps<void, SpotBiddingRulesErrorResponse, void, CreateSpotBiddingRuleRequest, void>,
  'path' | 'verb'
>

/**
 * Create a new spot bidding rule
 */
export const CreateSpotBiddingRule = (props: CreateSpotBiddingRuleProps) => (
  <Mutate<void, SpotBiddingRulesErrorResponse, void, CreateSpotBiddingRuleRequest, void>
    verb='POST'
    path='/v9/spot_bidding_rules'
    {...props}
  />
)

export type UseCreateSpotBiddingRuleProps = Omit<
  UseMutateProps<void, SpotBiddingRulesErrorResponse, void, CreateSpotBiddingRuleRequest, void>,
  'path' | 'verb'
>

/**
 * Create a new spot bidding rule
 */
export const useCreateSpotBiddingRule = (props: UseCreateSpotBiddingRuleProps) =>
  useMutate<void, SpotBiddingRulesErrorResponse, void, CreateSpotBiddingRuleRequest, void>(
    'POST',
    `/v9/spot_bidding_rules`,
    props
  )

export interface UpdateSpotBiddingRulePathParams {
  /**
   * Id of spot bidding rule to update
   */
  spotBiddingRuleId: number
}

export type UpdateSpotBiddingRuleProps = Omit<
  MutateProps<
    void,
    SpotBiddingRulesErrorResponse,
    void,
    UpdateSpotBiddingRuleRequest,
    UpdateSpotBiddingRulePathParams
  >,
  'path' | 'verb'
> &
  UpdateSpotBiddingRulePathParams

/**
 * Update an existing spot bidding rule
 */
export const UpdateSpotBiddingRule = ({
  spotBiddingRuleId,
  ...props
}: UpdateSpotBiddingRuleProps) => (
  <Mutate<
    void,
    SpotBiddingRulesErrorResponse,
    void,
    UpdateSpotBiddingRuleRequest,
    UpdateSpotBiddingRulePathParams
  >
    verb='PUT'
    path={`/v9/spot_bidding_rules/${spotBiddingRuleId}`}
    {...props}
  />
)

export type UseUpdateSpotBiddingRuleProps = Omit<
  UseMutateProps<
    void,
    SpotBiddingRulesErrorResponse,
    void,
    UpdateSpotBiddingRuleRequest,
    UpdateSpotBiddingRulePathParams
  >,
  'path' | 'verb'
> &
  UpdateSpotBiddingRulePathParams

/**
 * Update an existing spot bidding rule
 */
export const useUpdateSpotBiddingRule = ({
  spotBiddingRuleId,
  ...props
}: UseUpdateSpotBiddingRuleProps) =>
  useMutate<
    void,
    SpotBiddingRulesErrorResponse,
    void,
    UpdateSpotBiddingRuleRequest,
    UpdateSpotBiddingRulePathParams
  >(
    'PUT',
    (paramsInPath: UpdateSpotBiddingRulePathParams) =>
      `/v9/spot_bidding_rules/${paramsInPath.spotBiddingRuleId}`,
    { pathParams: { spotBiddingRuleId }, ...props }
  )
